import { Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Paper, Radio, RadioGroup, Step, StepLabel, Stepper, Typography } from "@mui/material";
import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from 'chart.js';
import React, { useEffect, useMemo, useState } from 'react';
import Select from "react-select";
import './DocterDashboard.scss';
// Register ChartJS components
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { Input, Table, Tag, Pagination } from "antd";
import ReactApexChart from 'react-apexcharts';
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useNavigate } from 'react-router-dom';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const appointments = [
  {
    name: "Shawn Hampton",
    appointment: "Emergency appointment",
    time: "10:00",
    price: "$30",
    avatar: "../images/avatar/4.jpg",
  },
  {
    name: "Polly Paul",
    appointment: "USG + Consultation",
    time: "10:30",
    price: "$50",
    avatar: "../images/avatar/5.jpg",
  },
  {
    name: "Johen Doe",
    appointment: "Laboratory screening",
    time: "11:00",
    price: "$70",
    avatar: "../images/avatar/6.jpg",
  },
  {
    name: "Harmani Doe",
    appointment: "Keeping pregnant",
    time: "11:30",
    price: "",
    avatar: "../images/avatar/7.jpg",
  },
  {
    name: "Mark Wood",
    appointment: "Primary doctor consultation",
    time: "12:00",
    price: "$30",
    avatar: "../images/avatar/8.jpg",
  },
  {
    name: "Shawn Marsh",
    appointment: "Emergency appointment",
    time: "13:00",
    price: "$90",
    avatar: "../images/avatar/9.jpg",
  },
];

const DocterDashboard = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState("2025-12-30");
  const [showModal1, setShowModal1] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState("");

  const [activeStep, setActiveStep] = useState(0);
  const [surgerySearch, setSurgerySearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const steps = [
    "Basic Info",
    "Emergency",
    "Health Overview",
    "Medications",
    "Family History",
    "Goals",
    "Final Input",
  ];
  const handleNext = () => setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  const handleBack = () => setActiveStep((prev) => Math.max(prev - 1, 0));
  const emergencyCases = [
    { name: "Jame Smith", disease: "Heart Attack", roomNo: 101, color: "red" },
    { name: "Mike Smith", disease: "Diabetes", roomNo: 102, color: "blue" },
    { name: "JJ Thomson", disease: "Asthma", roomNo: 103, color: "purple" },
    { name: "Rock Jameson", disease: "Stroke", roomNo: 104, color: "volcano" },

  ];

  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  const sexOptions = [
    { value: "MALE", label: "Male" },
    { value: "FEMALE", label: "Female" },
    { value: "INTERSEX", label: "Intersex" },
    { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
  ];

  const genderIdentityOptions = [
    { value: "MAN", label: "Man" },
    { value: "WOMAN", label: "Woman" },
    { value: "NON_BINARY", label: "Non-binary" },
    { value: "GENDERQUEER", label: "Genderqueer" },
    { value: "TRANSGENDER_MAN", label: "Transgender man" },
    { value: "TRANSGENDER_WOMAN", label: "Transgender woman" },
    { value: "DIFFERENT", label: "Different identity (write in)" },
    { value: "PREFER_NOT_TO_SAY", label: "Prefer not to say" },
  ];
  const supplementsOptions = [
    { value: "vitamins", label: "Vitamins" },
    { value: "herbal", label: "Herbal" },
    { value: "ayurvedic", label: "Ayurvedic" },
    { value: "homeopathic", label: "Homeopathic" },
    { value: "protein", label: "Protein supplements" },
    { value: "none", label: "None" },
  ];
  const conditionsOptions = [
    { value: "Hypertension", label: "Hypertension" },
    { value: "diabetes", label: "Diabetes" },
    { value: "heart", label: "Heart disease" },
    { value: "asthma", label: "Asthma" },
    { value: "Thyroid", label: "Thyroid" },
    { value: "PCOS", label: "PCOS" },
    { value: "Autoimmune", label: "Autoimmune" },
    { value: "Kidney", label: "Kidney" },
    { value: "Liver", label: "Liver" },
    { value: "Mental health", label: "Mental health" },
    { value: "Cancer", label: "Cancer" },
    { value: "Other", label: "Other" },
    { value: "None", label: "None" },



  ];
  const allergyOptions = [
    { value: "Nothing", label: "Nothing" },
    { value: "Medication", label: "Medication" },
    { value: "Food", label: "Foode" },
    { value: "Environmental", label: "Environmental" },
    { value: "Other", label: "Other" },
  ];

  const handleDateChange = (value: any) => {
    setDate(value);
  };


  const familyOptions = [
    { value: "heart", label: "Heart disease" },
    { value: "stroke", label: "Stroke" },
    { value: "diabetes", label: "Diabetes" },
    { value: "cancer", label: "Cancer" },
    { value: "autoimmune", label: "Autoimmune" },
    { value: "mental", label: "Mental health" },
    { value: "dementia", label: "Dementia" },
    { value: "none", label: "None" },
    { value: "not_sure", label: "Not sure" },
  ];

  const goalsOptions = [
    { value: "medication", label: "Medication safety" },
    { value: "symptoms", label: "Symptoms" },
    { value: "chronic", label: "Chronic care" },
    { value: "prevention", label: "Prevention" },
    { value: "lifestyle", label: "Lifestyle" },
    { value: "lab", label: "Lab understanding" },
  ];

  const selectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: "38px",
      borderColor: "#ced4da",
      boxShadow: "none",
      "&:hover": { borderColor: "#86b7fe" },
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  };
  const [date, setDate] = useState(new Date());
  // List of dates for the paginator
  const dates = [
    { date: "2025-12-22", title: "Monday, 22nd December 2025", label: "Mon<br>22nd" },
    { date: "2025-12-23", title: "Tuesday, 23rd December 2025", label: "Tue<br>23rd" },
    { date: "2025-12-24", title: "Wednesday, 24th December 2025", label: "Wed<br>24th" },
    { date: "2025-12-25", title: "Thursday, 25th December 2025", label: "Thu<br>25th" },
    { date: "2025-12-26", title: "Friday, 26th December 2025", label: "Fri<br>26th" },
    { date: "2025-12-27", title: "Saturday, 27th December 2025", label: "Sat<br>27th", off: true },
    { date: "2025-12-28", title: "Sunday, 28th December 2025", label: "Sun<br>28th", off: true },
    { date: "2025-12-29", title: "Monday, 29th December 2025", label: "Mon<br>29th" },
    { date: "2025-12-30", title: "Tuesday, 30th December 2025", label: "Tuesday<br>December 30th 2025", selected: true },
    { date: "2025-12-31", title: "Wednesday, 31st December 2025", label: "Wed<br>31st" },
    { date: "2026-01-01", title: "Thursday, 1st January 2026", label: "Thu<br>1st" },
    { date: "2026-01-02", title: "Friday, 2nd January 2026", label: "Fri<br>2nd" },
    { date: "2026-01-03", title: "Saturday, 3rd January 2026", label: "Sat<br>3rd", off: true },
    { date: "2026-01-04", title: "Sunday, 4th January 2026", label: "Sun<br>4th", off: true },
    { date: "2026-01-05", title: "Monday, 5th January 2026", label: "Mon<br>5th" },
    { date: "2026-01-06", title: "Tuesday, 6th January 2026", label: "Tue<br>6th" },
    { date: "2026-01-07", title: "Wednesday, 7th January 2026", label: "Wed<br>7th" },
    { date: "2026-01-08", title: "Thursday, 8th January 2026", label: "Thu<br>8th" },
  ];

  const handleDateClick = (date: React.SetStateAction<string>) => {
    setSelectedDate(date);
  };

  // Sample ECG Data
  const ecgData = {
    labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
    datasets: [
      {
        label: 'Heart Rate',
        data: [65, 70, 75, 72, 80, 78, 82, 85, 88, 84, 80, 78, 75, 72, 70],
        borderColor: '#1e88e5',
        backgroundColor: 'rgba(30, 136, 229, 0.1)',
        fill: true,
        tension: 0.4,
        pointRadius: 0,
      },
    ],
  };

  const ecgOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: { display: false },
      y: { display: false, min: 50, max: 100 },
    },
  };


  const stepContents = [

    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Full Name</label>
        <input type="text" className="form-control" placeholder="Enter full name" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Date of Birth</label>
        <input type="date" className="form-control" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Gender identity</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
          options={genderIdentityOptions}
          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label">Assigned at birth</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
          options={sexOptions}
          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label">Height</label>
        <input type="text" className="form-control" placeholder="cm or ft/in" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Weight</label>
        <input type="text" className="form-control" placeholder="kg or lbs" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Current Location</label>
        <input type="text" className="form-control" placeholder="Country, State/Region" />
      </div>
    </div>,


    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Emergency Contact Name</label>
        <input type="text" className="form-control" placeholder="Name" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Relationship</label>
        <input type="text" className="form-control" placeholder="Relationship" />
      </div>

      <div className="col-md-6">
        <label className="form-label">Phone Number</label>
        <input type="tel" className="form-control" placeholder="Phone Number" />
      </div>

      <div className="col-md-6">
        <label className="form-label">
          Can we contact this person in case of a serious health concern?
        </label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}

          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,


    <div className="row g-3">
      <div className="col-12">
        <label className="form-label">Diagnosed Conditions</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={conditionsOptions}
          isMulti

          placeholder="Select conditions"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-12">
        <label className="form-label">Allergies</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={allergyOptions}
          isMulti

          placeholder="Select allergies"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,


    <div className="row g-3">
      <div className="col-md-6">
        <label className="form-label">Currently taking medications?</label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={[
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
          ]}

          placeholder="Select"
          menuPortalTarget={document.body}
        />
      </div>

      <div className="col-md-6">
        <label className="form-label">Medication Names</label>
        <input
          type="text"
          className="form-control"
          placeholder="Medication name(s)"
        />
      </div>

      <div className="col-12">
        <label className="form-label">
          Supplements / Non-prescription Remedies
        </label>
        <Select
          styles={{
            ...selectStyles,
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999, // higher than MUI Dialog (default ~1300)
            }),
          }}
          options={supplementsOptions}
          isMulti

          placeholder="Select supplements"
          menuPortalTarget={document.body}
        />
      </div>
    </div>,


    <div className="col-12">
      <label className="form-label">
        Family History (Close family conditions)
      </label>
      <Select
        styles={{
          ...selectStyles,
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        options={familyOptions}
        isMulti

        placeholder="Select conditions"
        menuPortalTarget={document.body}
      />
    </div>,


    <div className="col-12">
      <label className="form-label">What would you like help with most?</label>
      <Select
        styles={{
          ...selectStyles,
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        options={goalsOptions}
        isMulti

        placeholder="Select up to 3"
        menuPortalTarget={document.body}
      />
    </div>,


    <div className="col-12">
      <label className="form-label">
        Is there anything you'd like us to know about your health right now?
      </label>
      <textarea
        className="form-control"
        rows={4}
        placeholder="Speak, Type, or Upload"
      />
    </div>,
  ];

  const bpData = [130, 125, 135, 140, 145];
  const hrData = [98, 100, 102, 105, 108];
  const glucoseData = [115, 118, 120, 122, 121];
  const oxygenData = [97, 98, 99, 97, 95];

  const commonOptions: any = {
    chart: {
      id: 'basic-line',
      type: 'line',
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    },
    yaxis: {
      show: true,
    },
  };


  const columns = [

    {
      title: "Doctor",
      dataIndex: "name",
      key: "name",
      render: (text: any, record: any) => (
        <div>
          <div>{text}</div>

        </div>
      ),
    },
    {
      title: "Surgery Type",
      dataIndex: "patientId",
      key: "patientId",
      render: (patientId: string | null) =>
        patientId ? (
          patientId
        ) : (
          <span className="pending-blink" onClick={() => setShowModal1(true)}>Pending</span>
        ),
    },



    {
      title: "Date & Time",
      dataIndex: "dob",
      key: "dob",
    },

    {
      title: "Patient",
      dataIndex: "name",
      key: "name",
      render: (text: any, record: any) => (
        <div>
          <div>{text}</div>
        </div>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: any) => {
        if (status === "Confirmed") {
          return <Tag color="green">Confirmed</Tag>;
        } else if (status === "Upcoming") {
          return <Tag color="yellow">Upcoming</Tag>;
        } else if (status === "Completed") {
          return <Tag color="red">Completed</Tag>;
        }
        return null;
      },
    },



  ];


  const dataSource = [
    {
      key: "1",
      patientId: "PID-001",
      name: "Sarah Johnson",
      relation: "Spouse",
      dob: "05/20/1985",
      gender: "Male",
      bloodGroup: "A+",
      phone: "123-456-7890",
      status: "Confirmed",
    },
    {
      key: "2",
      patientId: "PID-002",
      name: "Emily Johnson",
      relation: "Daughter",
      dob: "02/11/2013",
      gender: "Female",
      bloodGroup: "O+",
      phone: "123-456-7890",
      status: "Completed",
    },
    {
      key: "2",
      patientId: "PID-002",
      name: "Emily Johnson",
      relation: "Daughter",
      dob: "02/11/2013",
      gender: "Female",
      bloodGroup: "O+",
      phone: "123-456-7890",
      status: "Confirmed",
    },
    {
      key: "2",
      patientId: "PID-002",
      name: "Emily Johnson",
      relation: "Daughter",
      dob: "02/11/2013",
      gender: "Female",
      bloodGroup: "O+",
      phone: "123-456-7890",
      status: "Upcoming",
    },
    {
      key: "2",
      patientId: "PID-002",
      name: "Emily Johnson",
      relation: "Daughter",
      dob: "02/11/2013",
      gender: "Female",
      bloodGroup: "O+",
      phone: "123-456-7890",
      status: "Confirmed",
    },
    {
      key: "2",
      patientId: "PID-002",
      name: "Emily Johnson",
      relation: "Daughter",
      dob: "02/11/2013",
      gender: "Female",
      bloodGroup: "O+",
      phone: "123-456-7890",
      status: "Upcoming",
    },
  ];

  const filteredSurgeryData = useMemo(() => {
    if (!surgerySearch.trim()) return dataSource;
    const lower = surgerySearch.toLowerCase();
    return dataSource.filter((row: any) =>
      [row.name, row.patientId, row.dob, row.status]
        .some((val) => val && String(val).toLowerCase().includes(lower))
    );
  }, [dataSource, surgerySearch]);
  const paginatedSurgeryData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredSurgeryData.slice(start, start + pageSize);
  }, [filteredSurgeryData, currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(1);
  }, [surgerySearch]);

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(filteredSurgeryData.length / pageSize));
    if (currentPage > maxPage) {
      setCurrentPage(maxPage);
    }
  }, [filteredSurgeryData.length, pageSize, currentPage]);

  return (
    <div className="content-wrapper">
      <div className="container-full">
        <section className="content">
          <div className="row">

            <div className='col-7'>
              <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 p-4">
                {/* Welcome Header */}
                <div>
                  <h2 className="text-base font-bold text-gray-500">Welcome back</h2>
                  <h3 className="text-2xl font-bold text-gray-900 mt-1" style={{ color: 'rgba(22, 119, 255, 0.74)' }}>
                    DR. Sarah Smith!
                  </h3>
                  <p className="text-gray-600 mt-1 mb-5">Gynecologist, MBBS, MD</p>
                </div>

                <div style={{ display: "flex", gap: "20px", marginTop: "16px", flexWrap: "wrap" }}>
                  {/* Stat Card 1 */}
                  <div className="custom-stat-card">
                    <div className="white-inner-card">
                      <div className="text-section">
                        <span className="card-label">SURGERIES</span>
                        <h2 className="card-value">15+</h2>
                        <p className="card-trend">
                          <span className="percentage">+12%</span> since yesterday
                        </p>
                      </div>
                      <div className="card-icon-container">
                        {/* Replace <i> with your preferred icon library tag */}
                        <div className="icon-circle">
                          <i className="fa fa-calendar-check"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Stat Card 2 */}
                  <div className="custom-stat-card">
                    <div className="white-inner-card">
                      <div className="text-section">
                        <span className="card-label">ROOM VISITS</span>
                        <h2 className="card-value">32</h2>
                        <p className="card-trend">
                          <span className="percentage">+5%</span> since yesterday
                        </p>
                      </div>
                      <div className="card-icon-container">
                        <div className="icon-circle">
                          <i className="fa fa-hospital"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-5'>
              {/* Surgeries */}
              <Paper
                elevation={3}
                sx={{
                  p: 3, // reduced padding
                  minWidth: 200, // slightly bigger width
                  backgroundColor: '#ffffff', // clean white background
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 3, // slightly rounded corners
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)', // soft shadow
                }}
              >
                <Typography variant="subtitle2" sx={{ color: '#6b7280', mb: 1, fontSize: '14px' }}>
                  Appointments Today
                </Typography>

                {/* Doughnut Chart */}
                <ReactApexChart
                  type="donut"

                  height={250} // bigger chart
                  series={[3, 1, 2]} // Example: Surgeries, Consultations, Room Visits
                  options={{
                    labels: ['Scheduled ', 'Completed', 'Canceled'],
                    colors: ['#6366f1', '#f59e0b', '#10b981'], // soft modern colors
                    legend: {
                      show: true,
                      position: 'bottom',
                      fontSize: '14px',
                    },
                    chart: {
                      toolbar: { show: false },
                    },
                    tooltip: { enabled: true },
                    plotOptions: {
                      pie: {
                        donut: {
                          size: '80%', // slightly bigger donut
                          labels: {
                            show: true,
                            name: { show: true, fontSize: '16px' },
                            value: { show: true, fontSize: '18px', fontWeight: 'bold' },
                            total: {
                              show: true,
                              label: 'Total',
                              fontSize: '16px',
                              fontWeight: 600,
                              formatter: () => (3 + 1 + 2).toString(),
                            },
                          },
                        },
                      },
                    },
                    responsive: [
                      {
                        breakpoint: 480,
                        options: { chart: { height: 150 } },
                      },
                    ],
                  }}
                />
              </Paper>
            </div>

            {/* Main Patient Info & Vitals */}
            <div className="col-xxxl-9 col-xl-8 col-12">
              <div className="mb-20 d-flex justify-content-between align-items-center">

              </div>

              <div className="row">


                {/* Oxygen Card */}

                {/* Upcoming Appointments Section */}
                <div className="col-xxxl-8 col-xl-7 col-12">
                  <div className="box">
                    <div className="box-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <h4 className="box-title">Upcoming Surgeries and Procedures</h4>
                      <Input.Search placeholder="Search..." style={{ width: 220 }} value={surgerySearch} onChange={(e: any) => setSurgerySearch(e.target.value)} allowClear />
                    </div>
                    <Table
                      columns={columns}
                      dataSource={paginatedSurgeryData}
                      pagination={false}
                      className="family-table"
                       scroll={{ x: "max-content" }}
                    />
                    <div className="family-footer">
                      <span>Total {filteredSurgeryData.length} Records</span>
                      <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={filteredSurgeryData.length}
                        showSizeChanger
                        pageSizeOptions={["5", "10", "20", "50"]}
                        onChange={(page, size) => {
                          setCurrentPage(page);
                          setPageSize(size);
                        }}
                        onShowSizeChange={(_, size) => {
                          setCurrentPage(1);
                          setPageSize(size);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Notifications Section */}
                <div className="col-xxxl-4 col-xl-5 col-12 ">
                  <div className="box pb-4">

                    {/* Header */}
                    <div className="box-header">
                      <h4 className="box-title">
                        🚨 Emergency Cases ({emergencyCases.length})
                      </h4>
                    </div>


                    <div className="box-body notification-box">

                      {emergencyCases.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            background: "#fff7f7",
                            borderRadius: "10px",
                            padding: "12px 15px",
                            marginBottom: "12px",
                            // borderLeft: "5px solid #ff4d4f",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                          }}
                        >

                          {/* Name */}
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "15px",
                              marginBottom: "6px"
                            }}
                          >
                            {item.name}
                          </div>


                          {/* Bottom Row */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center"
                            }}
                          >

                            {/* Room */}
                            <span
                              style={{
                                background: "#ffe7ba",
                                padding: "3px 10px",
                                borderRadius: "6px",
                                fontSize: "12px",
                                fontWeight: "500"
                              }}
                            >
                              Room {item.roomNo}
                            </span>


                            {/* Disease */}
                            <Tag color={item.color}>
                              {item.disease}
                            </Tag>

                          </div>

                        </div>
                      ))}

                    </div>

                  </div>
                </div>
              </div>

            </div>

            {/* Right Sidebar - Appointments */}
            <div className="col-xxxl-3 col-xl-4 col-12">


              <div className="box b-0 bg-transparent no-shadow">
                <div className="box-body pb-0 px-0 d-flex align-items-center ">
                  <h4 className="mb-0 me-3">Appointment</h4>


                </div>
              </div>

              <div className="calendar-box">

                <Calendar
                  onChange={handleDateChange}
                  value={date}
                  className="custom-calendar"
                />

                <p className="mt-3">
                  Selected Date: {date ? date.toDateString() : ""}
                </p>

              </div>
            </div>
          </div>
        </section>
      </div>



      <Dialog
        open={showModal1}
        maxWidth="md"
        fullWidth
        className="auth-modal glass-modal"
        onClose={() => setShowModal1(false)}
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.2)", backdropFilter: "blur(5px)" },
        }}
      >

        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pt: 3,
            pb: 5,
          }}
        >
          <h3 style={{ margin: 0 }}>Initial Health Questionnaire</h3>
          <IconButton
            onClick={() => setShowModal1(false)}
            sx={{ color: "red" }} // red color
          >
            <CloseIcon sx={{ color: "gray", "&:hover": { color: "darkred" } }} />
          </IconButton>
        </DialogTitle>

        <DialogContent className="px-4 pb-3">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <form className="mt-3">{stepContents[activeStep]}</form>
        </DialogContent>

        <DialogActions className="pb-3 px-4 d-flex justify-content-end">

          <button
            className="btn btn-warning"
            disabled={activeStep === 0} onClick={handleBack}
          >
            Back
          </button>

          {activeStep === steps.length - 1 ? (

            <button className="btn btn-primary" onClick={() => setShowModal1(false)}>
              Save
            </button>

          ) : (

            <button className="btn btn-primary" onClick={handleNext}>
              Next
            </button>
          )}



        </DialogActions>
      </Dialog>

      <Dialog
        open={showConfirm}
        maxWidth="sm"
        fullWidth
        className="auth-modal glass-modal"
        onClose={() => setShowConfirm(false)}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.2)",
            backdropFilter: "blur(5px)",
          },
        }}
      >
        {/* HEADER */}
        <DialogTitle className="pt-30 pb-10 text-center">
          <h3 className="mb-1">Whom do you want to book an appointment </h3>
          <p className="text-muted fs-14 mb-0">
            Please select a family member
          </p>
        </DialogTitle>

        {/* CONTENT */}
        <DialogContent className="px-40 pb-20 d-flex justify-content-center">
          <RadioGroup
            row
            value={selectedPerson}
            onChange={(e) => setSelectedPerson(e.target.value)}
            className="justify-content-center mt-3"
          >
            <FormControlLabel value="self" control={<Radio />} label="Self" />
            <FormControlLabel value="father" control={<Radio />} label="Father" />
            <FormControlLabel value="mother" control={<Radio />} label="Mother" />
            <FormControlLabel value="sister" control={<Radio />} label="Sister" />
            <FormControlLabel value="spouse" control={<Radio />} label="Spouse" />
          </RadioGroup>
        </DialogContent>

        {/* FOOTER */}

        <DialogActions className="pb-3 px-4 d-flex justify-content-end gap-2">
          <button className="btn btn-warning"
            onClick={() => {
              // handle booking here
              setShowConfirm(false);
            }}>Cancel</button>
          <button className="btn btn-primary" onClick={() => { setShowConfirm(false); navigate("/appointment") }} disabled={!selectedPerson}>Schedule Appointment</button>
        </DialogActions>

      </Dialog>



    </div>
  );
};

export default DocterDashboard;